import React, { Fragment } from "react"
import PropTypes from "prop-types"
import Masthead from "components/Masthead"
import UnavailableSystemModal from "components/UnavailableSystemModal"
import styles from "./styles.css"

const Layout = ({ children }) => {
  return (
    <Fragment>
      <Masthead />

      <main className={`fullHeight ${styles.content}`}>{children}</main>

      <UnavailableSystemModal />
    </Fragment>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
}

export default Layout



// WEBPACK FOOTER //
// ./src/components/Layout/OldLayout.js